import { render, staticRenderFns } from "./lvshouTrainCamp.vue?vue&type=template&id=82ab6eca&scoped=true"
import script from "./lvshouTrainCamp.vue?vue&type=script&lang=js"
export * from "./lvshouTrainCamp.vue?vue&type=script&lang=js"
import style0 from "./lvshouTrainCamp.vue?vue&type=style&index=0&id=82ab6eca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ab6eca",
  null
  
)

export default component.exports